import React, { useEffect, useState } from "react";
import {
    createFolder,
    uploadFile,
    listFiles,
    deleteFile,
    renameFile,
    shareFile,
    unshareFile,
    downloadFile,
} from "../../../api/fileService";
import { Button, Container, Input, Row, Col } from "reactstrap";
import FileList from "../../../components/FileList";
import UploadModal from "../../../components/UploadModal";

const DrivePage = () => {
    const [files, setFiles] = useState([]);
    const [parentId, setParentId] = useState("");
    const [ownerId] = useState("user1"); // Hardcoded test user
    const [currentFolderId, setCurrentFolderId] = useState("");
    const [items, setItems] = useState([]);
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const [pagination, setPagination] = useState({ page: 0, size: 10 });
    const [page, setPage] = useState(0);
    const [size] = useState(10);
    const fetchData = async () => {
        const res = await listFiles(ownerId, parentId, pagination.page, pagination.size);
        setFiles(res.data.content);
    };

    const fetchItems = async () => {
        const response = await listFiles(ownerId, parentId, page, size);
        console.log(response)
        setItems(response.data.content);
    };

    useEffect(() => {
        fetchItems();
        console.log("DrivePage")
    }, [currentFolderId, page, parentId]);



    const handleFolderClick = (file) => {
        console.log(file)
        setCurrentFolderId(file.id)
        setParentId(file.parentFolderId)

        console.log(currentFolderId)
    };

    const handleUpload = async (filesToUpload) => {
        for (let file of filesToUpload) {
            const formData = new FormData();
            formData.append("file", file);
            await uploadFile(formData, ownerId, parentId);
        }
        fetchData();
        setUploadModalOpen(false);
    };

     const download = async (id) => {
        try {
            const response = await downloadFile(id)
            console.log(response)
            const blob = new Blob([response.data]);
            const downloadUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = downloadUrl;

            // Try to get filename from headers
            const contentDisposition = response.headers['content-disposition'];
            let fileName = "download";
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="([^"]+)"/);
                if (match && match[1]) {
                    fileName = match[1];
                }
            }
            console.log(fileName)
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (err) {
            console.error("Download failed", err);
        }
    };


    const handleCreateFolder = async () => {
        const name = prompt("Folder name?");
        if (name) {
            await createFolder(name, ownerId, parentId);
            fetchData();
        }
    };

    return (
        <Container>
            <Row className="my-3">
                <Col><h3>Drive</h3></Col>
                <Col className="text-end">
                    <Button color="primary" onClick={() => setUploadModalOpen(true)}>Upload</Button>{" "}
                    <Button color="secondary" onClick={handleCreateFolder}>New Folder</Button>
                </Col>
            </Row>
            <FileList
                files={items}
                onNavigate={handleFolderClick}
                onDelete={deleteFile}
                onRename={renameFile}
                onDownload={download}
                onShare={shareFile}
                onUnshare={unshareFile}
                refresh={fetchData}
            />

            {/*{items.map(item => (
                <div key={item.id}>
                    {item.isFolder ? (
                        <div onClick={() => setCurrentFolderId(item.id)}>
                            📁 {item.name}
                        </div>
                    ) : (
                        <div>
                            📄 {item.name}
                            <button onClick={() => download(item.id)}>Download</button>
                        </div>
                    )}
                </div>
            ))}*/}

            <UploadModal isOpen={uploadModalOpen} toggle={() => setUploadModalOpen(!uploadModalOpen)} onUpload={handleUpload} />
        </Container>
    );
};

export default DrivePage;
